import VideoTile from '@components/VideoTile';
import styled from '@emotion/styled';

export const Container = styled(VideoTile)`
  width: 80px;
  height: 60px;
  border: 1px solid #495057;
  border-radius: 6px;
  background-color: #161616;
`;
